import React from 'react'
import { App } from './views'
import { routesConfig } from './routesConfig'
import { AppIcon } from './components'
import { displayName, appName } from './appConfig'

export const appDefinition = {
  displayName,
  name:      appName,
  category:  'processes',
  Component: () => <App appName={appName} />,
  AppIcon,
  routes:    routesConfig(appName, displayName),
  // App Config areas this app opts into (surfaced on Admin Tools -> App Config).
  // The Nätverkande (networking-event) sub-feature posts to a Teams channel, so it
  // exposes its own webhook scope rather than a generic app-wide one — a future
  // sub-feature of network needing its own channel adds another entry here.
  appConfig: ['webhook'],
  webhookScopes: [
    { scope: `${appName}.networkingEvent`, label: 'Nätverkande' },
  ],
}
